import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRestrictDevices = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	id: "test",
	fillOpacity: 0,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_26115_3517)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M4.5 3.75L19.5 20.25",
				stroke: "#42296E",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M18 18.6V20.25C18 20.6478 17.842 21.0294 17.5607 21.3107C17.2794 21.592 16.8978 21.75 16.5 21.75H7.5C7.10218 21.75 6.72064 21.592 6.43934 21.3107C6.15804 21.0294 6 20.6478 6 20.25V5.40002",
				stroke: "#42296E",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.19061 2.25H16.5C16.8978 2.25 17.2793 2.40804 17.5606 2.68934C17.842 2.97064 18 3.35218 18 3.75V14.1403",
				stroke: "#42296E",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_26115_3517",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgRestrictDevices;
